import * as React from 'react';
import { useDispatch } from 'react-redux';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import LayoutDashboard from 'components/Layout/Dashboard';
import { triggerJob } from 'actions/Companies/TriggerJob';
import { enqueueSnackbarCustomMessage } from 'actions/Snackbar/resetSnackbar';

const styles = require('./styles.pcss');

function TriggerJob() {
  const dispatch = useDispatch();
  const [jobName, setJobName] = React.useState('');
  const [jsonInput, setJsonInput] = React.useState('');

  const showValidationError = (message: string) => {
    dispatch(enqueueSnackbarCustomMessage(message, 'error') as any);
  };

  const handleSubmit = () => {
    const trimmedJobName = jobName.trim();
    let parsedPayload: unknown;

    if (!trimmedJobName) {
      showValidationError('Job name is required.');
      return;
    }

    try {
      parsedPayload = JSON.parse(jsonInput);
    } catch (error) {
      showValidationError('Invalid JSON. Please fix the payload and retry.');
      return;
    }

    if (
      parsedPayload === null ||
      typeof parsedPayload !== 'object' ||
      Array.isArray(parsedPayload)
    ) {
      showValidationError('Payload must be a JSON object.');
      return;
    }

    dispatch(
      triggerJob(
        {
          jobName: trimmedJobName,
          body: parsedPayload as Record<string, unknown>,
        },
      ) as any,
    );
  };

  return (
    <LayoutDashboard full>
      <div className={styles.container}>
        <h1 className={styles.title}>Support Jobs</h1>
        <Card className={styles.formCard}>
          <CardContent>
            <Typography className={styles.description}>
              Submit a job name and JSON body to trigger a backend job.
            </Typography>
            <TextField
              label="Job name"
              fullWidth
              margin="normal"
              value={jobName}
              onChange={(event) => setJobName(event.target.value)}
            />
            <TextField
              label="Job body (JSON object)"
              multiline
              minRows={12}
              fullWidth
              margin="normal"
              className={styles.jobBody}
              value={jsonInput}
              onChange={(event) => setJsonInput(event.target.value)}
            />
            <div className={styles.actions}>
              <Button variant="contained" onClick={handleSubmit}>
                Run Job
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </LayoutDashboard>
  );
}

export default TriggerJob;
